export class ProductCollectionSeoTextModel {
    public HeaderText: string;
    public TitleTag: string;
    public MetaDesc: string;
    public TopDescription: string;
    public LongDescription: string;

    constructor(model: ProductCollectionSeoTextModel) {
        this.HeaderText = model.HeaderText;
        this.TitleTag = model.TitleTag;
        this.MetaDesc = model.MetaDesc;
        this.TopDescription = model.TopDescription;
        this.LongDescription = model.LongDescription;
    }
}

export interface ProductCollectionSettingModel {
    alwaysExpanded: boolean;
    previewSubitems: number | undefined | null;
    invisibleOnFilters: boolean;
    combineFilteringWithParent: boolean;
}

export class ProductCollectionModelBase {
    public Id: number;
    public Name: string;
    public RegisterLogicalName: boolean;
    public LogicalName: string;
    public SeoTexts: ProductCollectionSeoTextModel;
    public Settings: ProductCollectionSettingModel | null | undefined;
    public FullLogicalName: string;
    public Visible: boolean = true;
    public ProductCount?: number;
    public FilterViewMode: number | undefined | null;
    public Filler: boolean = false;

    constructor(model: ProductCollectionModelBase) {
        this.Id = model.Id;
        this.Name = model.Name;
        this.RegisterLogicalName = model.RegisterLogicalName;
        this.LogicalName = model.LogicalName;
        this.SeoTexts = model.SeoTexts;
        this.Settings = model.Settings;
        this.FullLogicalName = model.FullLogicalName;
        this.Visible = model.Visible;
        this.ProductCount = model.ProductCount;
        this.FilterViewMode = model.FilterViewMode;
        this.Filler = model.Filler === true;
    }
}

export interface IProductCollectionModel<
    TSubCollection extends ProductCollectionModelBase
> {
    SubCollections: TSubCollection[];
}

export class ProductCollectionModel
    extends ProductCollectionModelBase
    implements IProductCollectionModel<ProductCollectionModel>
{
    constructor(model: ProductCollectionModel) {
        super(model);
        this.SubCollections = model.SubCollections ?? [];
    }
    public SubCollections: ProductCollectionModel[] = [];
}

export class MappedProductCollectionModel
    extends ProductCollectionModel
    implements IProductCollectionModel<MappedProductCollectionModel>
{
    public parent: MappedProductCollectionModel | undefined = undefined;

    constructor(model: MappedProductCollectionModel) {
        super(model);
        this.parent = model.parent;
    }

    public SubCollections: MappedProductCollectionModel[] = [];
}
